import { Capacitor } from '@capacitor/core';
import { BiometricAuth, BiometryType } from '@aparajita/capacitor-biometric-auth';

const IS_NATIVE = Capacitor.isNativePlatform();
export const BIOMETRIC_PREF_KEY = 'ds_biometric_enabled';
export const BIOMETRIC_PROMPTED_KEY = 'ds_biometric_prompted';

export function biometricEnabled() {
  return localStorage.getItem(BIOMETRIC_PREF_KEY) === '1';
}
export function setBiometricEnabled(on) {
  localStorage.setItem(BIOMETRIC_PREF_KEY, on ? '1' : '0');
}

export async function biometricKindLabel() {
  if (!IS_NATIVE) return 'Biometric';
  try {
    const info = await BiometricAuth.checkBiometry();
    switch (info.biometryType) {
      case BiometryType.faceId:  return 'Face ID';
      case BiometryType.touchId: return 'Touch ID';
      case BiometryType.fingerprintAuthentication:
      case BiometryType.faceAuthentication:
      case BiometryType.irisAuthentication:
        return 'Biometric';
      default: return 'Biometric';
    }
  } catch { return 'Biometric'; }
}

export async function biometricAvailable() {
  if (!IS_NATIVE) return false;
  try {
    const info = await BiometricAuth.checkBiometry();
    return !!info.isAvailable;
  } catch { return false; }
}

/// Prompt the user. Resolves true on success, false on any failure/cancel.
export async function authenticateBiometric(reason = 'Unlock Day Sheets') {
  if (!IS_NATIVE) return false;
  try {
    await BiometricAuth.authenticate({
      reason,
      cancelTitle: 'Cancel',
      allowDeviceCredential: true, // passcode fallback if biometrics fails
      iosFallbackTitle: 'Use Passcode',
    });
    return true;
  } catch {
    return false;
  }
}
